
import { defineComponent, ref } from "vue";
import {process_matchinpayOTP, loadPaginatedMatchinPayHistory, process_matchinpayReload, process_matchinpayReload_DLQR}  from "@/api/matchinpay";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useRouter } from "vue-router"; 


export default defineComponent({
  name: "matchinpayprocess", 
  data(){
      return { 
        hasPendingMatchinPayOTP : false,
        optionsRadios : 1,
        totalAmount : "0",
        totalAmount2 : 0,
        model_matchinpay_otp : "0",
        isProcessingOTP : false,
        isProcessingReload : false,
        loading: true,
        topupfrom : 0,
        qrcodeFromQRPh : "",
        isShowProceed :  false
      }
  },
  methods: {
    selectTopUpFrom(){
      
      this.resetForm();
      
    },
    async loadPaginatedMatchinPayHistory(){ 
      this.loading = true;
        const response = await loadPaginatedMatchinPayHistory();
        this.hasPendingMatchinPayOTP = response.data.hasPendingMatchinPayOTP;
      this.loading = false;
    },
    async resetForm(){
      this.totalAmount = "0";
      this.totalAmount2 = 0;

      const radioA = this.$refs.option1 as HTMLInputElement;
      const radioB = this.$refs.option2 as HTMLInputElement;

      if (radioA) radioA.checked = false;
      if (radioB) radioB.checked = false;

      this.isShowProceed = false;
    },
    async cancel_matchinpayReload(){
      this.resetForm();
      this.topupfrom = 0;
    },
    async computeTotalAmount(amountClicked:number){
      var totalAmount = Number(amountClicked);

      if(totalAmount > 0){
        this.isShowProceed = true;
      } else {
        this.isShowProceed = false;
      }

      this.totalAmount2 = totalAmount;
      this.totalAmount = String(totalAmount);
      return totalAmount;
    },
    async process_matchinpayReload(){
      this.loading = true;
      if(isNaN(this.totalAmount2) || this.totalAmount2 == 0){
        this.isProcessingReload = true;
        Swal.fire({
              title: "",
              text: "Total must be greater than 0.",
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            this.isProcessingReload = false;
            //return;
      } else {
        this.isProcessingReload = true;
        var param = {"amount" : this.totalAmount2};
        const response = await process_matchinpayReload(param);

        if(response != null){
          this.isProcessingReload = false;
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            }); 
            window.location.reload();
            //return; 
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            //return; 
          }
        }
      }
      this.loading = false;
    },
    async process_matchinpayReload_DLQR(){
      this.loading = true;
      if(isNaN(this.totalAmount2) || this.totalAmount2 == 0){
        this.isProcessingReload = true;
        Swal.fire({
              title: "",
              text: "Total must be greater than 0.",
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            this.isProcessingReload = false;
            return false;
      } else {
        this.isProcessingReload = true;
        var param = {"amount" : this.totalAmount2};
        const response = await process_matchinpayReload_DLQR(param);
        
        if(response != null){
          
          if (response.data.result == "SUCCESS") {
            this.qrcodeFromQRPh = response.data.qrCode;

            if(this.qrcodeFromQRPh !== ""){
              this.$router.push({ name: "mgpaygenerateqr", params: { qrCode: this.qrcodeFromQRPh } });
            }
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
        this.isProcessingReload = false;
      }
      this.loading = false;
    },
    async process_matchinpayOTP(){
      this.loading = true;
      this.isProcessingOTP = true;
      var param = {"otp" : this.model_matchinpay_otp};
        const response = await process_matchinpayOTP(param);
        if(response != null){
          this.isProcessingOTP = false;
          
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            }); 
            window.location.reload();
            return; 
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
        this.loading = false;
    },
    async reset_matchinpay(){
      this.resetForm();
      this.cancel_matchinpayReload();
    },
  },
  mounted(){
      this.loadPaginatedMatchinPayHistory();
  },
  components: {},
  props: {
    widgetClasses: String,
    ccode : String,
    currency : String
  }
});
